<template>
  <footer class="py-4 bottom-0" style="background-color: white;">
    <div class="container mx-auto px-4 flex flex-col items-center">
      <img class="max-h-full object-contain w-5/12" src="@/assets/sponsors.png"/>
      
    </div>
  </footer>
</template>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
  name: 'FooterSection',
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },
}

</script>